import React, { useState } from "react";
import TypesOfSkillsSpecific from "./typesOfSkillsSpecific";
import paths from "@icarius-router/paths";
import { TypesOfSkillsIndicators } from "@icarius-pages/typesOfSkillsIndicators";
import { useLocation } from "react-router-dom";

const TypesOfSkillsSwitch = ({ history }) => {

  const [parametersIsOpen, setParametersIsOpen] = useState(false);
  const [parameter, setParameter] = useState(null);

  const location = useLocation();
  const handleOpenParameterPage = (process) => {
    setParameter(process);
    setParametersIsOpen(true);
  }

  const handleGoBack = () => {
    const from = location.state?.from;
    history.push(from || paths.performanceDefinition);
  }

  return (
    <>
      {
        parametersIsOpen ?
          <TypesOfSkillsIndicators
            parameter={parameter}
            handleGoBack={() => setParametersIsOpen(false)}
          />
          :
          <TypesOfSkillsSpecific
            handleGoBack={handleGoBack}
            handleOpenParameterPage={handleOpenParameterPage}
          />
      }
    </>
  );
}

export default TypesOfSkillsSwitch;